import { getCustomerList, insertFeedback, feedbackTypeList } from '@/api/qwH5Api';
export default {
  name: 'Home',
  data() {
    return {
      form: {
        company: '',
        contactTel: '',
        subTypeId: '',
        content: '',
        customerId: '',
        account: '',
        type: 2
      },
      id: '',
      loading: false,
      rules: {
        company: [{
          required: true,
          message: '公司名称不能为空',
          trigger: 'change'
        }],
        contactTel: [{
          required: true,
          message: '联系电话不能为空',
          trigger: 'change'
        }],
        subTypeId: [{
          required: true,
          message: '反馈类型不能为空',
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: '客户户号不能为空',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '反馈内容不能为空',
          trigger: 'blur'
        }]
      },
      options: [],
      tableData: [],
      tableLoading: true,
      options1: [],
      options2: [],
      options3: [],
      loading1: false,
      loading2: false,
      disabled: true,
      userId: ''
    };
  },
  components: {},
  mounted() {
    this.getType();
  },
  methods: {
    getType() {
      feedbackTypeList({
        type: 2
      }).then(res => {
        if (res.code == 1000) {
          this.options2 = res.data;
        }
        this.loading = false;
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        this.form.company = query;
        this.form.contactTel = '';
        getCustomerList(this.form).then(res => {
          if (res.code == 1000) {
            this.options = res.data;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.options = [];
        });
      } else {
        this.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== '') {
        this.loading1 = true;
        this.form.contactTel = query;
        this.form.company = '';
        this.form.account = '';
        getCustomerList(this.form).then(res => {
          if (res.code == 1000) {
            this.options1 = res.data;
          }
          this.loading1 = false;
        }).catch(() => {
          this.loading1 = false;
          this.options1 = [];
        });
      } else {
        this.options1 = [];
      }
    },
    remoteMethod2(query) {
      if (query !== '') {
        this.loading2 = true;
        this.form.account = query;
        this.form.contactTel = '';
        this.form.company = '';
        getCustomerList(this.form).then(res => {
          if (res.code == 1000) {
            this.options3 = res.data;
          }
          this.loading2 = false;
        }).catch(() => {
          this.loading2 = false;
          this.options3 = [];
        });
      } else {
        this.options3 = [];
      }
    },
    handleChange(val) {
      // 客户名称模糊搜索回填联系电话
      this.form.contactTel = val.contactTel;
      this.form.company = val.name;
      this.form.customerId = val.id;
      this.form.account = val.account;
    },
    closeWindow() {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", function () {
          WeixinJSBridge.call("closeWindow");
          parent.WeixinJSBridge.call('closeWindow');
        }, false);
      } else if (document.attachEvent) {
        document.attachEvent("onWeixinJSBridgeReady", function () {
          //这个可以关闭ios系统的手机
          WeixinJSBridge.call("closeWindow");
        });
      }
      // 必须加最后这一句，否则关闭不了
      WeixinJSBridge.call("closeWindow");
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            ...this.form
          };
          params.customerCompany = this.form.company;
          params.customerTel = this.form.contactTel;
          insertFeedback(params).then(res => {
            if (res.code == 1000) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.disabled = false;
              setTimeout(() => {
                this.closeWindow();
              }, 2000);
            } else {
              this.$message({
                message: res.message || '提交失败',
                type: 'error'
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};